import { Box, useTheme } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";

export const NAV_BAR = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Recommendation",
    path: "/recommendation",
  },
  {
    title: "Aggregation",
    path: "/aggregation",
  },
  {
    title: "Clustering aggregation",
    path: "/clustering-aggregation",
  },
  {
    title: "Cluster facets",
    path: "/cluster-facets",
  },
  {
    title: "Advance cluster aggregation",
    path: "/advance-cluster-aggregation",
  },
  {
    title: "Advance cluster facets",
    path: "/advance-cluster-facets",
  },
];

const NavigatorComponent: React.FC = () => {
  const theme = useTheme();
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" py={1}>
      {NAV_BAR.map((element) => (
        <Link
          to={element.path}
          key={element.title}
          style={{
            textDecoration: "none",
            color: theme.palette.common.white,
            paddingRight: theme.spacing(3),
            paddingBottom: theme.spacing(1),
            fontFamily: theme.typography.fontFamily,
          }}
        >
          {element.title}
        </Link>
      ))}
    </Box>
  );
};

export default NavigatorComponent;
